import { useQuery } from 'react-query'

import { globalSearchResultsQueryConfig } from '../../../query-configs'
import {
  GlobalSearchResult,
  type GlobalSearchResultConstructor,
} from '../../../value-objects/GlobalSearchResult'

const selectGlobalSearchResult = (constructor: GlobalSearchResultConstructor) =>
  new GlobalSearchResult(constructor)

export const useQueryGlobalSearchResults = (submittedQuery: string) => {
  const { data, isLoading, isError, error } = useQuery({
    ...globalSearchResultsQueryConfig.search(submittedQuery),
    enabled: submittedQuery !== '',
    select: selectGlobalSearchResult,
  })

  return { data, isLoading, isError, error }
}
